import { Component, OnInit , EventEmitter, Input, Output, SimpleChanges} from '@angular/core';

import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule, FormArray  } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../../services/user.service';
import { CommonDataService } from '../../../../services/common-data.service';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-product-delivery-details',
  templateUrl: './product-delivery-details.component.html',
  styleUrls: ['./product-delivery-details.component.scss']
})
export class ProductDeliveryDetailsComponent implements OnInit {

  modelForm: FormGroup;
  pageName = "Add New Product";
  modelName = "Product";
  toppingList: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];


  @Input() dataModel;
  @Input() dataModelId;
  @Output() formSubmitted = new EventEmitter<any>();


  localModelDataStorage = false;
  modelId = '0';
  modelData: any;
  returnData: any;
  files: any;

  filesToUpload: Array<File> = [];
  collectionWarehousePoints: FormArray;

  //mapbox search stuff
  searchForm: FormGroup;
  selectedAddress = [];
  addresses = [];

  query: any;
  showResults = false;
  loading = false;
  doneSearch = false;
  formDetected = false;

  addressObjects = []
  currentVariation = 0

  constructor(
    //private userService: UserService,
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService
  ) {}

  ngOnInit() {

    this.modelData = this.dataModel;
    this.modelId = this.dataModelId;

    $('#initialise-page').trigger('click');
    $('#owl-initialise').trigger('click');

  	this.modelForm = this.formBuilder.group({

      shipping_required: [false ],
      warehouse_required: [''], 
      selectedCouriers: [''], 
      collectionWarehousePoints: this.formBuilder.array([ this.createItem() ]),
      productShippingUniqueTag: [''], 
      weight: [''], 
      length: ['' ], 
      width: [''], 
      height: [''], 
      shippingInstructions: [''], 
      requiresTransportationPermit: [''], 
      acceptShippmentTermsAndConditions: [''], 
    });

    // this.searchForm = this.formBuilder.group({
    //   searchable: [''],
    // });

    this.prepopulate();

  }

  shippingRequired() {

    let required = this.modelForm.controls['shipping_required'].value
    if(!required) {
      this.modelForm.controls['selectedCouriers'].clearValidators(); // remove validation
      this.modelForm.controls['productShippingUniqueTag'].clearValidators();
      this.modelForm.controls['weight'].clearValidators();
      this.modelForm.controls['length'].clearValidators();
      this.modelForm.controls['width'].clearValidators();
      this.modelForm.controls['acceptShippmentTermsAndConditions'].clearValidators();
    }

    else {

      // this.modelForm.controls['selectedCouriers'].setValidators([Validators.required])
      this.modelForm.controls['productShippingUniqueTag'].setValidators([Validators.required])
      this.modelForm.controls['weight'].setValidators([Validators.required])
      this.modelForm.controls['length'].setValidators([Validators.required])
      this.modelForm.controls['width'].setValidators([Validators.required])
      // this.modelForm.controls['acceptShippmentTermsAndConditions'].setValidators([Validators.required])

    }
  }

  get f() { return this.modelForm.controls; }

  prepopulate(){

      for (var key in this.modelData) {  // 'field' is a string

        if (this.modelData[key] instanceof Array || this.modelData[key] instanceof Object) {
      
          var innerModelDataObject;

          if (this.modelData[key] instanceof Object) {
            innerModelDataObject = Object.values(this.modelData[key]);

            var innerModelDataObject2 = this.modelData[key];
            console.log(innerModelDataObject2);

            for (const [objectKey, value] of Object.entries(this.modelData[key])) {
              console.log(`${objectKey} ${value}`); // "a 5", "b 7", "c 9"

              for (const objectfield in this.modelForm.controls) {
  
                if(this.modelData[key][objectfield] && objectfield != 'collectionWarehousePoints') {
                  
                  this.modelForm.get(objectfield).setValue(this.modelData[key][objectfield]);
                  console.log(objectfield);
                }
      
              }
            }
          }

          //not sure what to do with arrays as yet...

          if (this.modelData[key] instanceof Array) {

            // for (var objectKey in this.modelData[key]) {

            //   alert('value is Array!'+ objectKey);
  
            // }
          }
          
          
        }

        else {

          for (const field in this.modelForm.controls) {
            // console.log(key)
            if(this.modelData[field]) {

              this.modelForm.get(field).setValue(this.modelData[field]);
              //const control = this.modelForm.get(field); // 'control' is a FormControl
              // console.log(field);
    
              //console.log(control);
            }

          }

        }


        if(this.modelData['productShipping']['collectionWarehousePoints']) {
          // alert('done')productShipping-collectionWarehousePoints
          // alert('done')
          console.log(this.modelData['productShipping']['collectionWarehousePoints'])
         var sizevariations = JSON.parse(this.modelData['productShipping']['collectionWarehousePoints']);
  
        this.collectionWarehousePoints = this.modelForm.get('collectionWarehousePoints') as FormArray;
        this.removeVariation(0)
          
  
         for(let i =0; i < sizevariations.length; i++) {
  
            let sizeItem = this.formBuilder.group({
              // size: sizevariations[i]['size'],
              // description: sizevariations[i]['description'],
              // price: sizevariations[i]['price'],
              // color: sizevariations[i]['color'],
              // stock: sizevariations[i]['stock']
              collection_name: sizevariations[i]['collection_name'],
              collection_address: sizevariations[i]['collection_address'],
              collection_lat: sizevariations[i]['collection_lat'],
              collection_lng: sizevariations[i]['collection_lng'],
              collection_opening_time: sizevariations[i]['collection_opening_time'],
              collection_closing_time: sizevariations[i]['collection_closing_time'],
              collection_phone: sizevariations[i]['collection_phone'],
              collection_email: sizevariations[i]['collection_email'],
              collection_post_code: sizevariations[i]['collection_post_code'],
              collection_baundary_name: sizevariations[i]['collection_baundary_name']
            });
  
            this.collectionWarehousePoints.push(sizeItem);
  
            this.currentVariation += 1
         }
  
         
  
        }

        

      }
  }
  createItem(): FormGroup {
    return this.formBuilder.group({
      collection_name: '',
      collection_address: '',
      collection_lat: '',
      collection_lng: '',
      collection_opening_time: '',
      collection_closing_time: '',
      collection_phone: '',
      collection_email: '',
      collection_post_code: '',
      collection_baundary_name: ''
    });
  }

  addItem(): void {
    this.collectionWarehousePoints = this.modelForm.get('collectionWarehousePoints') as FormArray;
    this.collectionWarehousePoints.push(this.createItem());
    this.currentVariation += 1

    //form create new warehouse point 
  }

  // addItem(): void {
  //   this.sizes = this.modelForm.get('sizes') as FormArray;
  //   this.sizes.push(this.createItem());
  //   this.currentVariation += 1
  // }

  removeVariation(i): void {
    this.collectionWarehousePoints = this.modelForm.get('collectionWarehousePoints') as FormArray;
    this.collectionWarehousePoints.removeAt(i);
    this.currentVariation -= 1
  }


  //mapbox
  search(event, i) {
    this.query = event.target['value'];
    this.showResults = true;
    this.loading = true;

    if (this.query.length > 2) {
      var formData = new FormData();
      formData.append('search_term', this.query)
      formData.append('limit', '10')
      formData.append('country', 'za')

      this._data.getAddress(formData).subscribe(
        data => {
        this.addresses[i] = data.data['addresses']
        //console.log('addresses are is: '+JSON.stringify(this.addresses))
        // this.scrollToBottom();
        },
        err => {
          console.log('error')
        },
        () => {}
      );
      this.loading = false;
    }
  }

  addressSelect (fullAddress, lat, lng, address, i) {

    alert(fullAddress)
    this.showResults = false;
    // this.doneSearch = true;
    // this.searchForm.get('searchable').disable();
    this.selectedAddress[i] = fullAddress;
    //console.log('selected selectedAddress is: '+this.selectedAddress);
    localStorage.setItem('selectedAddress', JSON.stringify(address));


    //let log = this.modelForm.get('collectionWarehousePoints') //.setValue(this.files);
    let warehouses = this.modelForm.get('collectionWarehousePoints');
    console.log(warehouses)
    // warehouses.controls[i].get('collection_lng').setValue(lng)
    // this.modelForm.controls.collectionWarehousePoints.controls[i].controls.name.value
    // this.modelForm.controls['collectionWarehousePoints']['controls'][i].controls['collection_lng'].setValue(lng)
    // warehouses.controls[i]['controls']['collection_lng'].setValue(lng)
    let collectionWarehousePoints = this.modelForm.get('collectionWarehousePoints') as FormArray;


    collectionWarehousePoints.at(i).patchValue(
      { collection_lng: lng, collection_lat: lat,collection_post_code: address.postCode,collection_baundary_name: address.town, collection_address: fullAddress  }
    );

    // 1 - run geocode
    // this._map.setMarker([lng, lat]);
    // this._map.setMarkerCreate(true);

    // 2 - send message
    // var formData = new FormData();
    // Object.keys(address).forEach((key)=>{formData.append(key,address[key])});

    // this._msg.sendAddress(formData)

  }

  searchResetOnBackspace (event, i) {
    if (event.keyCode === 8 && this.selectedAddress[i]) { // if you hit backspace and have already selected a result, reset
        console.log('cleansed!');
        this.selectedAddress[i] = event.target['value'];
        this.search(event, i); // repopulate results
    }
  };

  // scrollToBottom () {
  //   let target;
  //   target = $('.search-result').last();
  //   if (target) {
  //     $('html,body').animate({ scrollTop: $(target).offset().top - 110 }, 'slow', () => {
  //       target.focus();
  //     });
  //   }
  // }
  //mapbox end

  onFileChanged(event) {
    //this.files = event.target.files[0];
    //this.modelForm.get('images').setValue(this.files);

    this.filesToUpload = <Array<File>>event.target.files;
  }

  onSubmit() {

    //alert('working magic!')
    $('#buttonText').text('Please Wait...');
    $('#loader').show();

    if (this.modelForm.invalid) {
      console.log('errors are detected');
      this.markFormGroupTouched(this.modelForm);

      $('#buttonText').text('Update Shipping Info ');
      $('#loader').hide();

      return;
    }

    console.log('Details being saved in the service: '+JSON.stringify(this.modelForm.value))

    this.createProduct(); // run combine function
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  createProduct() {

    let modelObject1 = new FormData();

    modelObject1.append('modelName', this.modelName);
    modelObject1.append('id', this.modelId);
    modelObject1.append('productShipping-shipping_required', this.modelForm.controls['shipping_required'].value);
    modelObject1.append('productShipping-warehouse_required', this.modelForm.controls['warehouse_required'].value);
    modelObject1.append('productShipping-selectedCouriers', this.modelForm.controls['selectedCouriers'].value);
    // modelObject1.append('productShipping-collectionWarehousePoints', this.modelForm.controls['collectionWarehousePoints'].value);
    modelObject1.append('productShipping-productShippingUniqueTag', this.modelForm.controls['productShippingUniqueTag'].value);
    // modelObject1.append('productShipping-weight', this.modelForm.controls['weight'].value);
    // modelObject1.append('productShipping-length', this.modelForm.controls['length'].value);
    // modelObject1.append('productShipping-width', this.modelForm.controls['width'].value);
    // modelObject1.append('productShipping-height', this.modelForm.controls['height'].value);
    modelObject1.append('productShipping-shippingInstructions', this.modelForm.controls['shippingInstructions'].value);
    modelObject1.append('productShipping-requiresTransportationPermit', this.modelForm.controls['requiresTransportationPermit'].value);
    modelObject1.append('productShipping-acceptShippmentTermsAndConditions', this.modelForm.controls['acceptShippmentTermsAndConditions'].value);

    let warehouses = this.modelForm.get('collectionWarehousePoints') as FormArray;
    modelObject1.append("productShipping-collectionWarehousePoints", JSON.stringify(this.modelForm.controls.collectionWarehousePoints.value));


    // const files: Array<File> = this.filesToUpload;
    // console.log(files);

    // for(let i =0; i < files.length; i++){
    //     modelObject1.append("uploads[]", files[i]);
    // }


    this.updateModel(modelObject1);

  }

  updateModel (modelObject: any) {
    // Initiate new model creation/update method

    this._data.updateModelData(modelObject) 
      .pipe(first())
      .subscribe(
        data => {
 
          this.returnData = data;

          this.modelId = data['result']['id'];
          this.modelData = data['result']['model']['modelData']['formFieldsEntities'];
          console.log('this is the new model return object: '+JSON.stringify(this.returnData));
        },
        error => {
          console.log(error);

          $('#buttonText').text('Update Shipping Info');
          $('#loader').hide();

        },

        () => {

          iziToast.success({
              title: 'Success!',
              position: 'topRight',
              icon: 'icon-circle-check',
              message: 'Your product updated successfuly.'
          });

          $('#buttonText').text('Update Shipping Info');
          $('#loader').hide();

          //this.router.navigate(['/sellers/account/product-settings/?id='+id]);
          let details = {
            step : "delivery",
            completed : true,
            next: "image",
            dataModel: this.modelData,
            modelId: this.modelId
          }
          this.formSubmitted.emit(details);
            
        }
      );
  }

  viewGallery()
  {
  	this.router.navigate(['/sellers/account/product-gallery']);
  }

  ngOnChanges(changes: SimpleChanges) {
    // only run when property "data" changed

    // if (changes['dataModel']) {
    //   this.modelData = changes['dataModel'].currentValue;
    //   this.prepopulate();
    // }
   
  }

}
